/**
 * Source: https://github.com/franzenzenhofer/parseUri/blob/master/parseuri.js
 * Modules should require this file, and not from npm, since we set strictMode = true here.
 *
 * A regex parser that takes a URL and parses it into various components. Using an
 * external library here because some utilities are shared between Node and browser
 * bundles so we can't rely on the DOM API for this.
 *
 * Supports absolute URLs with protocol (http://www.pinterest.com/foo) and protocol-relative
 * URLs (//www.pinterest.com/foo/bar) and relative URLs (foo/bar) (will return blank values for
 * things like host, protocol, etc).
 *
 * Does not support absolute URLs with no protocol (www.pinterest.com/something/something)
 *
 * UPDATE: 10/7/16
 * "parseUri" module inlined below due to case-insensitive package name collision with "parseuri"
 * Became an issue with npm@3 dependency flattening & socket.io-client which requires "parseuri"
 *
 * See:
 *  - https://github.com/ashleygwilliams/npm-sandbox/tree/master/npm3/example1
 *  - https://npmjs.com/package/parseuri
 *  - https://npmjs.com/package/parseUri
 *  - https://github.com/npm/npm/issues/7933
 */

// Code b/w eslint comments is original parseUri code
/* eslint eslint-comments/no-unlimited-disable:0 */
/* eslint eslint-comments/no-restricted-disable:0 */
/* eslint-disable */

// a node.js module fork of
// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License
// see: http://blog.stevenlevithan.com/archives/parseuri
// see: http://stevenlevithan.com/demo/parseuri/js/

function parseUri(str) {
  var o = parseUri.options,
    m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str),
    uri = {},
    i = 14;

  while (i--) uri[o.key[i]] = m[i] || '';

  uri[o.q.name] = {};
  uri[o.key[12]].replace(o.q.parser, function($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2;
  });

  return uri;
}

parseUri.options = {
  strictMode: false,
  key: [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor',
  ],
  q: {
    name: 'queryKey',
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g,
  },
  parser: {
    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:(?<!\\)@]*)(?::([^:@]*))?)?@)?([^:\/?#\\]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
    loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/,
  },
};

/* eslint-enable */

parseUri.options.strictMode = true;

module.exports = parseUri;
